export default "__VITE_ASSET__6991cf90__"